import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { CreateView, renderErrorOrLoading } from 'components/Crud';
import { skillDomain } from 'models';
import useStyles from 'components/Crud/styles';
import { useSkillCategoriesState } from 'store/selectors';
import { fetchAllSkillCategories } from 'store/slices/skillCategories';
import { getSkillsInputFieldsProps, validationSchema } from './FormConfig';

function AddSkillView() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    items: skillCategoriesData,
    isLoading,
    error
  } = useSkillCategoriesState();

  useEffect(() => {
    dispatch(fetchAllSkillCategories());
  }, []);

  return (
    renderErrorOrLoading(isLoading, 'addEngineerSpinner', error, classes) || (
      <CreateView
        domain={skillDomain}
        fields={getSkillsInputFieldsProps('add', skillCategoriesData)}
        validationSchema={validationSchema}
      />
    )
  );
}

export default AddSkillView;
